<template>
  <div>
    <b-form-group
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    > 
      <phone-input defaultCountry=" " :placeholder="properties.placeholder"></phone-input>
    </b-form-group>
    <div v-if="showType == 'properties'">
      <phone-input-v1-properties :formId="formId" />
    </div>
    <b-form-group
      style="font-size: 14px"
      v-if="
        showType == 'form-submitter' ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'description',
              value: properties.description,
              defaultValue: '',
              form: this.form
            })
          : properties.description
      "
      :label="
        computedConditions.label
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'label',
              value: properties.label,
              defaultValue: '',
              form: this.form
            })
          : properties.label
      "
      :style="properties.style"
      :hidden="computedHidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <phone-input
        style="font-size: 14px"
        :placeholder="
          computedConditions.placeholder
            ? superComputeFormSubmitterValue({
                elementId: this.id,
                property: 'placeholder',
                value: properties.placeholder,
                defaultValue: '',
                form: this.form
              })
            : properties.placeholder
        "
        :readonly="
          computedConditions.readonly
            ? superComputeFormSubmitterValue({
                elementId: this.id,
                property: 'readonly',
                value: properties.readonly,
                defaultValue: false,
                form: this.form
              })
            : properties.readonly
        "
        :required="
          computedConditions.required
            ? superComputeFormSubmitterValue({
                elementId: this.id,
                property: 'required',
                value: properties.required,
                defaultValue: false,
                form: this.form
              })
            : properties.required
        "
        v-model="localValue"
        @blur="controlValue = localValue"
        :state="state"
        defaultCountry=" "
      ></phone-input>
    </b-form-group>
    <b-form-group
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.label
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'label',
              value: properties.label,
              defaultValue: '',
              form: this.form
            })
          : properties.label
      "
    >
       {{ localValue }}
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import PhoneInputV1Properties from "./PhoneInputV1Properties.vue";
import PhoneInput from "../../../controls/PhoneInput.vue"
export default {
  name: "PhoneInputV1",
  components: { PhoneInputV1Properties, PhoneInput },
  props: ["showType", "properties", "form", "id", "results", "formId"],
  data() {
    return {
      computedProperties: [
        "description",
        "label",
        "hidden",
        "placeholder",
        "readonly",
        "required"
      ],
      computedConditions: {},
      localValue: ""
    };
  },
  mounted() {
    if (
      !this.getFormSubmitterComponentValue(this.id) &&
      (this.showType == "form-submitter" || this.showType == "e-form")
    ) {
      this.setFormSubmitterComponentValue({
        controlId: this.id,
        controlValue: this.properties.value
          ? this.superComputeFormSubmitterValue({
              elementId: this.id,
              property: "value",
              value: this.properties.value,
              defaultValue: "",
              form: this.form
            })
          : this.properties.value
      });
    }
    this.localValue = this.controlValue;
    if (this.showType == "form-submitter" || this.showType == "e-form") {
      this.setFormSubmitterComponentMetadata({
        controlId: this.id,
        controlMetadata: {
          label: this.properties.label
        }
      });
    }
    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", [
      "setFormSubmitterComponentValue",
      "setFormSubmitterComponentMetadata"
    ]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div style="font-size: 14px" tabindex="-1" role="group" class="bv-no-focus-ring">
          ${
            this.controlValue
              ? this.controlValue
              : ""
          }
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "superComputeFormSubmitterValue",
      "computeFormSubmitterValue"
    ]),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      }
    }),
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'hidden',
            value: this.properties.hidden,
            defaultValue: false,
            form: this.form
          })
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
    
  },
  watch: {
    controlValue(newValue) {
      if (newValue != this.localValue) {
        this.localValue = newValue;
      }
    }
  }
};
</script>
